import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useTheme,
  Theme,
} from "@mui/material";
import useMembers from "../../hooks/members/useMembers";
import { MemberPartialDto } from "../../types/membersTypes";

/**
 * Displays the list of birthdays
 */
const BirthdayList: React.FC = () => {
  const theme = useTheme();
  const { members } = useMembers();

  /**
   * Retrieves the members date of birth
   */
  const sortMembersByBirthday = (members: MemberPartialDto[]) => {
    const currentMonth = new Date().getMonth();

    return [...(members || [])].sort((a, b) => {
      const dateA = new Date(a.birthday);
      const dateB = new Date(b.birthday);
      const monthA = dateA.getMonth();
      const monthB = dateB.getMonth();
      const dayA = dateA.getDate();
      const dayB = dateB.getDate();

      /**
       * Sorts the data so that the current month is at the top
       */
      const monthSort = ((monthA - currentMonth + 12) % 12) - ((monthB - currentMonth + 12) % 12);
      return monthSort || dayA - dayB;
    });
  };

  /**
   * Renders the table header
   */
  const renderTableHeader = (theme: Theme) => (
    <TableHead>
      <TableRow>
        <TableCell
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            width: "85%",
            fontWeight: "bold",
          }}
        >
          Name
        </TableCell>
        <TableCell
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            width: "15%",
            fontWeight: "bold",
          }}
        >
          Geburtsdatum
        </TableCell>
      </TableRow>
    </TableHead>
  );

  /**
   * Renders the rows
   */
  const renderTableBody = (sortedMembers: MemberPartialDto[], theme: Theme) => (
    <TableBody>
      {sortedMembers.map((member, index) => {
        const previousMember = sortedMembers[index - 1];
        const currentMemberMonth = new Date(member.birthday).getMonth();
        const previousMemberMonth = previousMember ? new Date(previousMember.birthday).getMonth() : null;

        return (
          <React.Fragment key={member.memberId}>
            {previousMemberMonth !== currentMemberMonth && (
              <TableRow sx={{ height: "10px" }}>
                <TableCell
                  colSpan={2}
                  sx={{
                    fontWeight: "bold",
                    fontSize: "0.8rem",
                    textAlign: "center",
                    padding: "5px",
                    backgroundColor: theme.palette.grey[200],
                  }}
                >
                  {new Date(2000, currentMemberMonth, 1).toLocaleString("de-DE", { month: "long" })}
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>{`${member.firstname} ${member.lastname}`}</TableCell>
              <TableCell>
                {new Date(member.birthday).toLocaleDateString("de-DE", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
              </TableCell>
            </TableRow>
          </React.Fragment>
        );
      })}
    </TableBody>
  );
  const sortedMembers = sortMembersByBirthday(members);

  return (
    <TableContainer component={Paper}>
      <Table>
        {renderTableHeader(theme)}
        {renderTableBody(sortedMembers, theme)}
      </Table>
    </TableContainer>
  );
};

export default BirthdayList;
